
const endpointMetadataKey = 'cortrack.endpoint.decorator';
export function endpoint(uri: string) {
  return (target: object) => {
    Reflect.set(target, endpointMetadataKey, uri);
  };
}

export function getEndpoint(target: object): string {
  return Reflect.get(target, endpointMetadataKey);
}
